<template>
  <div class="headerReports">
    <h1>{{ $t('report.label.list.title') }}</h1>
    <v-container>
      <v-row no-gutters>
        <v-col md="4" sm="6" class="pa-2" v-for="(item, i) in reportsList" :key="i">
          <v-card class="cardStyle">
            <v-card-title>{{ item.reportName }}</v-card-title>
            <div class="icon-item" >
              <img :src="item.icon"/>
            </div>
            <div class="d-flex justify-end pa-2">
              <detailReport :reportProps="item"/>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  ACTION_GET_LIST_REPORTS,
  GET_LIST_REPORTS,
  REPORTS_M,
} from "@/views/reports/store/types/types.js";
import { mapActions, mapGetters } from "vuex";
import detailReport from "@/views/reports/pages/detail_report/detail_report_page.vue";

export default {
  name: "listReportsComponent",
  components: {
    detailReport,
  },
  async mounted() {
    await this.getReports();
  },

  methods: {
    ...mapActions({
      getReports: `${REPORTS_M}${ACTION_GET_LIST_REPORTS}`,
    }),
  },
  computed: {
    ...mapGetters({
      reports: `${REPORTS_M}${GET_LIST_REPORTS}`,
    }),

    reportsList() {
      return this.reports || [];
    },
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.icon-item {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.icon-item img {
  width: 60%;
  height: 100%;
  object-fit: contain;
  padding-right: 10px;
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
  height: 200px;
  width: 300px;
  display: flex;
  flex-direction: column;
}

.cardStyle .v-card__title {
  font-size: 1.1rem;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  white-space: normal;
  padding: 16px;
  flex-grow: 1;
  display: flex;
  align-items: flex-start;
  min-height: 60px;
  max-height: 80px;
}

.headerReports {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  .cardStyle .v-card__title {
    font-size: 0.9rem;
    line-height: 1.3;
    min-height: 50px;
    max-height: 70px;
    padding: 12px;
  }

  .icon-item {
    height: 80px;
  }
}

@media screen and (min-width: 415px) and (max-width: 768px) {
  h1 {
    font-size: 3.5vh;
    margin-left: 2vh;
  }

  .cardStyle .v-card__title {
    font-size: 1rem;
    line-height: 1.35;
    min-height: 55px;
    max-height: 75px;
    padding: 14px;
  }
}

@media screen and (min-width: 769px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }

  .cardStyle .v-card__title {
    font-size: 1.1rem;
    line-height: 1.4;
    min-height: 60px;
    max-height: 80px;
    padding: 16px;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 2.5vh;
    margin-left: 1vh;
  }

  h2 {
    font-size: 2vh;
  }

  .cardStyle .v-card__title {
    font-size: 0.8rem;
    line-height: 1.25;
    min-height: 45px;
    max-height: 65px;
    padding: 10px;
  }

  .icon-item {
    height: 60px;
  }
}
</style>
